/* rayrot-asistente.js -- widget propio del chatbot de Rayrot (Fase 4 del plan
   "Chatbot propio Rayrot"). Sustituye a Shopify Inbox. Autocontenido: no
   depende de ninguna libreria externa ni de Liquid, asi que se sirve tal
   cual como asset estatico del tema. */
(function () {
  "use strict";

  var ENDPOINT = "https://bot.srv1039429.hstgr.cloud/chat";
  var LS_CLIENTE = "rayrot_asistente_cliente_id";
  var LS_CONV = "rayrot_asistente_conversation_id";

  function uuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0, v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function clienteId() {
    var v = localStorage.getItem(LS_CLIENTE);
    if (!v) { v = uuid(); localStorage.setItem(LS_CLIENTE, v); }
    return v;
  }

  function conversationId() {
    return localStorage.getItem(LS_CONV) || null;
  }

  function guardaConversationId(id) {
    localStorage.setItem(LS_CONV, id);
  }

  var CSS = ""
    + "#rayrot-asistente-burbuja{position:fixed;right:20px;bottom:20px;z-index:99998;"
    + "width:56px;height:56px;border-radius:50%;background:#111013;color:#FDFBF7;"
    + "border:none;cursor:pointer;box-shadow:0 4px 16px rgba(17,16,19,.25);"
    + "font-size:26px;display:flex;align-items:center;justify-content:center;"
    + "transition:transform .15s ease;}"
    + "#rayrot-asistente-burbuja:hover{transform:scale(1.06);}"
    + "#rayrot-asistente-saludo{position:fixed;right:86px;bottom:30px;z-index:99998;"
    + "background:#FDFBF7;color:#111013;padding:10px 14px;border-radius:14px;"
    + "box-shadow:0 4px 16px rgba(17,16,19,.18);font:14px/1.4 -apple-system,"
    + "BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;max-width:200px;"
    + "opacity:0;pointer-events:none;transition:opacity .25s ease;}"
    + "#rayrot-asistente-saludo.visible{opacity:1;}"
    + "#rayrot-asistente-panel{position:fixed;right:20px;bottom:88px;z-index:99999;"
    + "width:340px;max-width:calc(100vw - 32px);height:480px;max-height:calc(100vh - 140px);"
    + "background:#FDFBF7;border-radius:16px;box-shadow:0 8px 32px rgba(17,16,19,.28);"
    + "display:none;flex-direction:column;overflow:hidden;"
    + "font:14px/1.5 -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;color:#111013;}"
    + "#rayrot-asistente-panel.abierto{display:flex;}"
    + "#rayrot-asistente-cabecera{background:#111013;color:#FDFBF7;padding:14px 16px;"
    + "display:flex;align-items:center;justify-content:space-between;flex:none;}"
    + "#rayrot-asistente-cabecera strong{font-size:15px;}"
    + "#rayrot-asistente-cerrar{background:none;border:none;color:#FDFBF7;font-size:20px;"
    + "cursor:pointer;line-height:1;padding:4px;}"
    + "#rayrot-asistente-mensajes{flex:1;overflow-y:auto;padding:14px;display:flex;"
    + "flex-direction:column;gap:10px;background:#FDFBF7;}"
    + ".rayrot-msg{max-width:82%;padding:9px 12px;border-radius:14px;white-space:pre-wrap;"
    + "word-wrap:break-word;}"
    + ".rayrot-msg-bot{align-self:flex-start;background:#EFEAE0;color:#111013;"
    + "border-bottom-left-radius:4px;}"
    + ".rayrot-msg-yo{align-self:flex-end;background:#AED98D;color:#111013;"
    + "border-bottom-right-radius:4px;}"
    + ".rayrot-msg a{color:#111013;font-weight:600;text-decoration:underline;}"
    + ".rayrot-msg code{background:rgba(17,16,19,.08);padding:1px 5px;border-radius:4px;"
    + "font-family:ui-monospace,'SF Mono',Menlo,monospace;font-size:.9em;}"
    + ".rayrot-msg-aviso{align-self:center;background:transparent;color:#7a7568;"
    + "font-size:12px;text-align:center;max-width:95%;}"
    + "#rayrot-asistente-form{flex:none;display:flex;gap:8px;padding:10px;border-top:1px solid #EFEAE0;background:#FDFBF7;}"
    + "#rayrot-asistente-input{flex:1;border:1px solid #d9d3c4;border-radius:20px;padding:9px 14px;"
    + "font-size:14px;outline:none;background:#fff;color:#111013;}"
    + "#rayrot-asistente-input:focus{border-color:#AED98D;}"
    + "#rayrot-asistente-enviar{background:#111013;color:#FDFBF7;border:none;border-radius:50%;"
    + "width:38px;height:38px;flex:none;cursor:pointer;font-size:16px;}"
    + "#rayrot-asistente-enviar:disabled{opacity:.5;cursor:default;}"
    + "#rayrot-asistente-escribiendo{align-self:flex-start;background:#EFEAE0;border-radius:14px;"
    + "border-bottom-left-radius:4px;padding:11px 14px;display:flex;gap:4px;}"
    + "#rayrot-asistente-escribiendo span{width:6px;height:6px;border-radius:50%;background:#8a8474;"
    + "animation:rayrot-punto 1.1s infinite ease-in-out;}"
    + "#rayrot-asistente-escribiendo span:nth-child(2){animation-delay:.15s;}"
    + "#rayrot-asistente-escribiendo span:nth-child(3){animation-delay:.3s;}"
    + "@keyframes rayrot-punto{0%,60%,100%{opacity:.3;transform:translateY(0);}30%{opacity:1;transform:translateY(-3px);}}"
    + "@media (max-width:420px){#rayrot-asistente-panel{right:16px;left:16px;width:auto;bottom:84px;}"
    + "#rayrot-asistente-saludo{right:16px;}}";

  function inyectaCSS() {
    var s = document.createElement("style");
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  var elPanel, elMensajes, elInput, elEnviar, elBurbuja, elSaludo;

  function construyeDOM() {
    elBurbuja = document.createElement("button");
    elBurbuja.id = "rayrot-asistente-burbuja";
    elBurbuja.setAttribute("aria-label", "Abrir el chat de Rayrot");
    elBurbuja.innerHTML = "👋";
    document.body.appendChild(elBurbuja);

    elSaludo = document.createElement("div");
    elSaludo.id = "rayrot-asistente-saludo";
    var idiomaNav = (navigator.language || "es").toLowerCase();
    elSaludo.textContent = idiomaNav.indexOf("es") === 0 ? "¿Necesitas ayuda?" : "Need help?";
    document.body.appendChild(elSaludo);

    elPanel = document.createElement("div");
    elPanel.id = "rayrot-asistente-panel";
    elPanel.innerHTML =
      '<div id="rayrot-asistente-cabecera"><strong>Rayrot</strong>' +
      '<button id="rayrot-asistente-cerrar" aria-label="Cerrar chat">✕</button></div>' +
      '<div id="rayrot-asistente-mensajes"></div>' +
      '<form id="rayrot-asistente-form">' +
      '<input id="rayrot-asistente-input" type="text" placeholder="Escribe tu pregunta..." autocomplete="off">' +
      '<button id="rayrot-asistente-enviar" type="submit" aria-label="Enviar">→</button>' +
      "</form>";
    document.body.appendChild(elPanel);

    elMensajes = document.getElementById("rayrot-asistente-mensajes");
    elInput = document.getElementById("rayrot-asistente-input");
    elEnviar = document.getElementById("rayrot-asistente-enviar");
  }

  function escapaHTML(t) {
    var d = document.createElement("div");
    d.textContent = t;
    return d.innerHTML;
  }

  // Markdown minimo y seguro: primero se escapa TODO el texto a entidades
  // HTML (incluido lo que el cliente haya escrito en su propio mensaje, por
  // si Gemini lo repite), y solo sobre ese texto ya inerte se aplican estas
  // transformaciones controladas -- nunca se inserta HTML sin escapar antes.
  function formateaMensaje(texto) {
    var t = escapaHTML(texto);
    t = t.replace(/^#{1,6} +(.+)$/gm, "<strong>$1</strong>");
    t = t.replace(/^[*-] +/gm, "• ");
    t = t.replace(/`([^`\n]+)`/g, "<code>$1</code>");
    t = t.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    t = t.replace(/\*([^*\n]+)\*/g, "<em>$1</em>");
    t = t.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
    return t;
  }

  function pintaMensaje(texto, clase) {
    var div = document.createElement("div");
    div.className = "rayrot-msg " + clase;
    div.innerHTML = formateaMensaje(texto);
    elMensajes.appendChild(div);
    elMensajes.scrollTop = elMensajes.scrollHeight;
  }

  var AVISO_IA = "¡Hola! Soy Rayo, ¿en qué puedo ayudarte?";

  function primeraApertura() {
    return !conversationId();
  }

  function abrePanel() {
    elPanel.classList.add("abierto");
    elSaludo.classList.remove("visible");
    if (primeraApertura() && !elMensajes.hasChildNodes()) {
      pintaMensaje(AVISO_IA, "rayrot-msg-bot");
    }
    elInput.focus();
  }

  function cierraPanel() {
    elPanel.classList.remove("abierto");
  }

  function ponCargando(activo) {
    elEnviar.disabled = activo;
    elInput.disabled = activo;
  }

  var RETRASO_MINIMO_MS = 3000;

  function ponEscribiendo(activo) {
    var existente = document.getElementById("rayrot-asistente-escribiendo");
    if (activo && !existente) {
      var d = document.createElement("div");
      d.id = "rayrot-asistente-escribiendo";
      d.innerHTML = "<span></span><span></span><span></span>";
      elMensajes.appendChild(d);
      elMensajes.scrollTop = elMensajes.scrollHeight;
    } else if (!activo && existente) {
      existente.remove();
    }
  }

  function enviaMensaje(texto) {
    pintaMensaje(texto, "rayrot-msg-yo");
    ponCargando(true);
    ponEscribiendo(true);
    var empezado = Date.now();
    var cuerpo = {
      canal: "web",
      cliente_id: clienteId(),
      mensaje: texto,
      mensaje_id: uuid(),
    };
    var cid = conversationId();
    if (cid) cuerpo.conversation_id = cid;

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cuerpo),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("http_" + r.status);
        return r.json();
      })
      .then(function (d) {
        if (d.conversation_id) guardaConversationId(d.conversation_id);
        return muestra(function () { pintaMensaje(d.respuesta, "rayrot-msg-bot"); });
      })
      .catch(function () {
        return muestra(function () {
          pintaMensaje(
            "Se me ha atascado la respuesta un segundo -- prueba a mandar el mensaje otra vez, o escribe a contact@rayrot.com si prefieres.",
            "rayrot-msg-aviso"
          );
        });
      })
      .finally(function () {
        ponCargando(false);
        elInput.focus();
      });

    // El "escribiendo..." se queda visible un minimo de tiempo, aunque la
    // API responda al instante -- sino el chat se nota demasiado robotico.
    function muestra(pinta) {
      var faltan = RETRASO_MINIMO_MS - (Date.now() - empezado);
      return new Promise(function (resolve) {
        setTimeout(function () {
          ponEscribiendo(false);
          pinta();
          resolve();
        }, Math.max(0, faltan));
      });
    }
  }

  function arranca() {
    inyectaCSS();
    construyeDOM();

    elBurbuja.addEventListener("click", function () {
      if (elPanel.classList.contains("abierto")) cierraPanel();
      else abrePanel();
    });
    document.getElementById("rayrot-asistente-cerrar").addEventListener("click", cierraPanel);
    document.getElementById("rayrot-asistente-form").addEventListener("submit", function (e) {
      e.preventDefault();
      var texto = elInput.value.trim();
      if (!texto) return;
      elInput.value = "";
      enviaMensaje(texto);
    });

    // Burbuja de saludo casi inmediata, en cada visita -- asi se ve a
    // simple vista que es un chat, no solo un icono suelto.
    setTimeout(function () {
      if (!elPanel.classList.contains("abierto")) elSaludo.classList.add("visible");
    }, 600);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arranca);
  } else {
    arranca();
  }
})();
